import React, { Component } from "react";
import Table from "../../components/Table/AnswerTable.jsx";
// import Moment from "react-moment";
import {
  Collapse,
  Alert,
  Button,
  FormControl,
  ControlLabel,
  FormGroup,
  Row,
  Col,
  Grid
} from "react-bootstrap";
import { Card } from "../../components/Card/Card.jsx";
import "../../assets/css/demo.css";
import {
  addAnswer,
  getQuestion,
  editAnswer,
  closeNotification,
  setAnswerCorrect,
  deleteAnswer
} from "../../services/QuestionServices";

class ViewQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: null,
      answers: null,
      addAnswer: false,
      formTextField: "",
      formOrderField: "",
      ansWeight:"",
      alert: "warning",
      status: "UNKNOWN",
      message: "UNKNOWN",
      isShowing: false
    };
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    
    this.handleChangeWeight = this.handleChangeWeight.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAnswerUpdate = this.handleAnswerUpdate.bind(this);
    this.handleAnswerDelete = this.handleAnswerDelete.bind(this);
    

  }

  handleCloseClick() {
    this.setState({ addAnswer: false });
  }

  handleChangeText(e) {
    const target = e.target;
    this.setState({ formTextField: target.value });
  }

  handleChangeOrder(e) {
    const target = e.target;
    this.setState({ formOrderField: target.value });
  }

  handleChangeWeight(e){
    const target = e.target;
    this.setState({ansWeight:target.value});
  }

  handleAnswerUpdate(object) {
    console.log('da answero', object._id);
    
    const outsideThis = this;
    editAnswer(this.state.question._id, object._id, object)
      .then((response) => {
        if (response.data.err) {
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState(
            {
              question: response.data.question, 
              answers: response.data.question.answers,
              message: "Updated answer : " + object.text,
              isShowing: true,
              status: "SUCCESS!",
              alert: "success",
            }
          );
        }
      })
      .catch((err) => {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  handleAnswerDelete(object) {
    const outsideThis = this;
    deleteAnswer(this.state.question._id, object._id)
      .then((response) => {
        if (response.data.err) {
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState(
            {
              question: response.data.question, 
              answers: response.data.question.answers,
              message: "Deleted answer : " + object.text,
              isShowing: true,
              status: "SUCCESS!",
              alert: "success",
            }
          );
        }
      })
      .catch((err) => {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  handleSubmit(e) {
    const outsideThis = this;
    this.setState({ isShowing: false });
    addAnswer(outsideThis.state.question._id,
      {
      text: this.state.formTextField,
      order: this.state.formOrderField,
      weight: this.state.ansWeight
    })
      .then(function(response) {
        if (response.data.err) {
          console.log(response.data.err);
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            addAnswer: false,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState(
            {
              message: "Added a new answer:",
              question: response.data.question,
              answers: response.data.question.answers,
              isShowing: true,
              addAnswer: false,
              status: "SUCCESS!",
              alert: "success"
            }
          );
        }
      })
      .catch(function(err) {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  handleCheck(answerId, index) {
    console.log("Handling check")
    const answers = this.state.answers.slice();
    answers[index].weight = 28;
    console.log("The index",index);
    console.log("the ans id",answerId);
    console.log(answers);
    this.setState({
      answers: answers.map((item, index1) => {
        index === index1 ? (item.weight = item.weight) : (item.weight = 10);
        return item;
      })
    });

    setAnswerCorrect(this.state.question._id, answerId).then(object =>
      console.log("updated")
    );
  }

  componentDidMount() {
    const questionId = this.props.location.pathname.split("/")[4];
    getQuestion(questionId).then(object =>
      this.setState({
        question: object.data.question,
        answers: object.data.question.answers
      })
      
    );
    
    // TODO: Catch errors and display internal server error
  }

  render() {
    console.log("entered");
    const text = this.state.question ? this.state.question.text : "";
    return (
      <div className="content">
        <h1 align="center"> Question: &nbsp; {text}</h1>
        <br />
        <h3 align="left"> Answers:</h3>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Collapse in={this.state.isShowing}>
                <Row>
                  <Col xs={6} md={4}>
                    <Alert bsStyle={this.state.alert}>
                      <strong>{this.state.status}</strong> {this.state.message}
                    </Alert>
                  </Col>
                </Row>
              </Collapse>

              <Table
                onCheck={this.handleCheck}
                objecttype="answers"
                answers={this.state.answers}
                attributes={["text", "order", "weight"]}
                onUpdate={this.handleAnswerUpdate}
                onDelete={this.handleAnswerDelete}
              />

              {!this.state.addAnswer ? (
                <Button
                  onClick={() => this.setState({ addAnswer: true })}
                  className="right"
                  bsStyle="primary"
                  bsSize="large"
                >
                  Add an answer
                </Button>
              ) : (
                <Card
                  onClick={this.handleCloseClick}
                  closable="true"
                  title="Add a new Answer"
                  content={
                    <form>
                      <FormGroup controlId="formBasicText">
                        <Row>
                          <Col xs={6} md={4}>
                            <ControlLabel>Answer Text</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.formTextField}
                              placeholder="Enter the text of the Answer"
                              onChange={this.handleChangeText}
                            />
                          </Col>
                          <Col xs={6} md={4}>
                            <ControlLabel>Order</ControlLabel>
                            <FormControl
                              type="number"
                              min="1"
                              value={this.state.formOrderField}
                              placeholder="Enter the order of this answer in the question"
                              onChange={this.handleChangeOrder}
                            />
                          </Col>
                          <Col xs={6} md={4}>
                            <ControlLabel>Weight</ControlLabel>
                            <FormControl
                              type="number"
                              min="1"
                              value={this.state.ansWeight}
                              placeholder="Enter the weight of this answer in the question"
                              onChange={this.handleChangeWeight}
                            />
                          </Col>

                        </Row>
                      </FormGroup>

                      <Button
                        onClick={this.handleSubmit}
                        bsStyle="info"
                        fill="true"
                      >
                        Add Answer
                      </Button>
                      <div className="clearfix" />
                    </form>
                  }
                />
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default ViewQuestion;



// WEBPACK FOOTER //
// ./src/views/Question/ViewQuestion.jsx